import { VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Loader } from 'Molecules';
import {
  EsrsAssessmentsYearsQuery_,
  GetIntegrationApiKeyQuery_,
  useEsrsAssessmentsYearsQuery,
  useGetIntegrationApiKeyQuery,
} from 'models';
import { useParams } from 'react-router-dom';
import { IntegrationTable } from './IntegrationTable';
import { IntegrationInput } from './IntegrationInput';

export type MoreScopeCompanyRow = EsrsAssessmentsYearsQuery_['esrsAssessments'][0];
export type CompanyIntegration = GetIntegrationApiKeyQuery_['esrs_CompanyIntegration'][0];

export enum SavingState {
  save = 0,
  saving = 1,
  saved = 2,
}

export const MoreScopeCompany = () => {
  const { companyId = '' } = useParams();

  const { data, loading: dataLoading } = useGetIntegrationApiKeyQuery({
    variables: {
      companyId,
      integrationSystemName: 'moreScope',
    },
    skip: !companyId,
  });
  const integration = useMemo(() => data?.esrs_CompanyIntegration?.[0], [data]);

  const { data: esrsAssessmentsData, loading: esrsAssessmentsLoading } =
    useEsrsAssessmentsYearsQuery({
      variables: {
        companyId,
        companyIntegrationId: integration?.id,
      },
      skip: !companyId,
    });
  const assessments = useMemo(() => esrsAssessmentsData?.esrsAssessments, [esrsAssessmentsData]);

  if (dataLoading || esrsAssessmentsLoading) {
    return <Loader height={'100px'} />;
  }
  return (
    <VStack mt="15px" alignItems={'flex-start'} width={'100%'} gap={0}>
      <IntegrationInput integration={integration} />
      <IntegrationTable integration={integration} assessments={assessments} />
    </VStack>
  );
};
